import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="blueprint-grid bg-ink px-3 py-4 sm:px-6" data-id="element-41" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-42" data-mp="1mau696x7ahe4">
        <h2 className="font-display text-[1.35rem] font-extrabold uppercase leading-none text-white sm:text-[1.85rem]" data-id="element-43" data-mp="1r585xliwbaol">
          THIS ISN'T JUST ANOTHER CONSTRUCTION MANAGEMENT EBOOK.
        </h2>
        <p className="mt-1 font-display text-[0.78rem] font-bold uppercase text-hazard sm:text-[0.95rem]" data-id="element-44" data-mp="ze2cfnxokb8a">
          IT'S A READY-TO-USE JOBSITE MANAGEMENT SYSTEM.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-45" data-mp="18cw20uclg1cc">
          {differentiators.map((item, i) => {
          const isLastOdd = i === differentiators.length - 1 && differentiators.length % 2 === 1;
          return <div key={item.title} className={`rounded-md border border-line bg-graphite px-2.5 py-2 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-46" data-mp="2js2qsjjmkc2l" data-mpi={i}>
                <h3 className="font-display text-[0.8rem] font-bold text-white sm:text-[0.92rem]" data-id="element-47" data-mp="bniyxjrowz6b">
                  <span aria-hidden="true" data-id="element-48" data-mp="7nqpl4uh2ozw">{item.emoji}</span> {item.title}
                </h3>
                <p className="mt-0.5 text-[0.76rem] leading-[1.35] text-steel sm:text-[0.86rem]" data-id="element-49" data-mp="2mukinydwwsw">{item.body}</p>
              </div>;
        })}
        </div>
        <p className="mt-2 font-display text-[0.76rem] font-extrabold uppercase text-white sm:text-[0.9rem]" data-id="element-50" data-mp="3ovvwx6ntxpxg">
          Less paperwork from scratch. Fewer scattered records.{' '}
          <span className="text-hazard" data-id="element-51" data-mp="3g323m5bjsq0l">More organized construction sites.</span>
        </p>
      </div>
    </section>;
}